import React from 'react'
import { compose, branch, renderNothing, renderComponent } from 'recompose'
import IconSVG from 'svg-inline-react'

import { Button } from '@driftt/tide-core-legacy'

class AssistantConfigOrgSettings extends React.Component {
  render() {
    const { assistantSetting, orgSettings, handleEdit, hasPassedOnboarding, sfFieldTitle } = this.props

    const sfLeadObject = orgSettings.get('salesforceLeadObject')
    const sfLeadField = orgSettings
      .get('sfLeadFields')
      .keySeq()
      .first()
    const sfEventObject = orgSettings.get('salesforceEventObject')
    const sfEventField = orgSettings
      .get('sfEventFields')
      .keySeq()
      .first()
    const openOps = orgSettings.get('followUpWithOpenOps')

    const sfLeadFieldValues = sfLeadField ? orgSettings.getIn(['sfLeadFields', sfLeadField]) : []
    const sfLeadFieldValueText =
      sfLeadFieldValues.size > 0 ? (
        <span>
          &nbsp;is&nbsp;
          <strong>{sfLeadFieldValues.join(', ')}</strong>
        </span>
      ) : (
        ''
      )
    const sfEventFieldValues = sfEventField ? orgSettings.getIn(['sfEventFields', sfEventField]) : []
    const sfEventFieldValueText =
      sfEventFieldValues.size > 0 ? (
        <span>
          &nbsp;is&nbsp;
          <strong>{sfEventFieldValues.join(', ')}</strong>
        </span>
      ) : (
        ''
      )

    const connectedIcon = (
      <IconSVG
        className="status-icon"
        src={require('!svg-inline?removeTags=true!images/svg/check-circle-green.svg')}
      />
    )

    const customSalesforceLeadConditions = sfLeadField && (
      <span className="assistant-config-custom-settings">
        With the property: <strong>{sfFieldTitle}</strong>
        {sfLeadFieldValues.size > 0 && sfLeadFieldValueText}
      </span>
    )
    const customSalesforceEventConditions = sfEventField && (
      <span className="assistant-config-custom-settings">
        With the property: <strong>{sfFieldTitle}</strong>
        {sfEventFieldValues.size > 0 && sfEventFieldValueText}
      </span>
    )

    return (
      <div className="assistant-config-settings-view">
        {assistantSetting === 'salesforceMapping' && (
          <div>
            <div className="list-header">
              {hasPassedOnboarding && connectedIcon}
              <h4>The Drift Assistant will remind your team about:</h4>
            </div>
            <ul>
              <li>
                Salesforce {sfLeadObject.toLocaleLowerCase()}s{customSalesforceLeadConditions}
              </li>
              {openOps && <li>Open Opportunities</li>}
            </ul>
          </div>
        )}
        {assistantSetting === 'salesforceActivity' && (
          <div>
            <div className="list-header">
              {hasPassedOnboarding && connectedIcon}
              <h4>The Drift Assistant will know a demo&rsquo;s been held on:</h4>
            </div>
            <ul>
              <li>
                Salesforce {sfEventObject.toLocaleLowerCase()}s{customSalesforceEventConditions}
              </li>
            </ul>
          </div>
        )}
        <Button
          type="secondary"
          onClick={() => handleEdit({ isEditingValue: true, isSFDCOutOfSyncValue: false })}
        >
          Configure
        </Button>
      </div>
    )
  }
}

const SalesforceOutOfSyncError = props => {
  const { assistantSetting, handleEdit } = props
  const skillDetails =
    assistantSetting === 'salesforceMapping'
      ? 'meeting reminder skills'
      : 'meeting reminder skills to follow up with next steps after demos'

  const disconnectedIcon = (
    <IconSVG
      className="status-icon"
      src={require('!svg-inline?removeTags=true!images/svg/status-icon-danger.svg')}
    />
  )

  return (
    <div className="assistant-config-settings-view">
      <div className="SFDC-error-state">
        <div className="list-header">
          {disconnectedIcon}
          <h4>
            Oh no! The original mappings for your Drift Assistant{' '}
            <strong>no longer match your Salesforce account</strong>.
          </h4>
        </div>
        <p className="error-message-info">
          You need to reconfigure the Drift Assistant so your team can keep using the {skillDetails}.
        </p>
      </div>
      <Button
        type="secondary"
        onClick={() => handleEdit({ isEditingValue: true, isSFDCOutOfSyncValue: true })}
      >
        Configure
      </Button>
    </div>
  )
}

export default compose(
  branch(props => !props.orgSettings, renderNothing),
  branch(props => props.salesforceOutOfSync, renderComponent(SalesforceOutOfSyncError))
)(AssistantConfigOrgSettings)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/AssistantConfigOrg/AssistantConfigOrgSettings/index.js